import { observable, makeObservable } from "mobx"

class UserAgentStore {
  isMobile = false
  isModal = false

  constructor() {
    makeObservable(this, {
      isMobile: observable,
      isModal: observable,
    })
  }
}

export default new UserAgentStore()
